import { FC, Fragment } from "react";

interface AvailabilityCellProps {
  enabled: boolean;
}

export const AvailabilityCell: FC<AvailabilityCellProps> = ({ enabled }) => {
  return <Fragment>{enabled ? "Enabled" : "Disabled"}</Fragment>;
};
